import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import PostList from '../components/PostList'
import PostSpotlight from '../components/PostSpotlight'
import Pagination from '../components/Pagination'
import Babypedia from '../components/Babypedia'

export const IndexPage = props => {
  const { data, pageContext } = props
  const { nodes: posts } = data.allWpPost

  return (
    <Layout>
      <Babypedia title />
      <PostSpotlight />
      <PostList posts={posts} title="Postagens" />
      <Pagination pageContext={pageContext} pathPrefix="/" />
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query IndexQuery($limit: Int!, $skip: Int!) {
    allWpPost(sort: { fields: date, order: DESC }, limit: $limit, skip: $skip) {
      nodes {
        date
        excerpt
        id
        title
        slug
        uri
        featuredImage {
          node {
            sourceUrl
            localFile {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
        categories {
          nodes {
            id
            name
            categorias {
              color
              imagemPadrao {
                sourceUrl
                localFile {
                  childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
